import React, {Fragment, useEffect, useState} from "react";
import {DropdownMenu, DropdownToggle, Dropdown} from "reactstrap";
import {FaBell} from "react-icons/fa";
import {useDispatch, useSelector} from "react-redux";
import Button from "../Button";
import NotificationsList from "./NotificationsList";
import DeleteModal from "../Modal/DeleteModal";
import ProtectedContent from "../protectedContent";
import {
  deleteNotifications,
  requestNotifications,
  markAllNotificationAsRead,
} from "../../redux/Actions/notifications.action";
import {
  getNotifications,
  getUnreadCount,
} from "../../redux/Selectors/notification.selector";
import {getCurrentCustomer} from "../../redux/Selectors/customers.selectors";
import "./notification.scss";

const NotificationMenu = () => {
  const dispatch = useDispatch();
  const notifications = useSelector(getNotifications);
  const unreadCount = useSelector(getUnreadCount);
  const currentCustomer = useSelector(getCurrentCustomer);
  const [modalStatus, setModalStatus] = useState(false);
  const [isOpen, setOpen] = useState(false);

  useEffect(() => {
    if (currentCustomer.id) {
      dispatch(requestNotifications());
    }
  }, [dispatch, currentCustomer]);

  const showDeleteModal = () => {
    setModalStatus(true);
  };

  const markAllAsRead = () => {
    dispatch(markAllNotificationAsRead());
  };

  const toggleDropdown = () => {
    setOpen(!isOpen);
  };

  const handleDelete = () => {
    const callback = () => {
      setModalStatus(false);
      toggleDropdown();
    };
    dispatch(deleteNotifications(callback));
  };

  return (
    <Fragment>
      <DeleteModal
        header={"Delete All Notifications"}
        modalBody={"Are you sure you want to delete all notifications ?"}
        onClose={() => setModalStatus(false)}
        onDelete={handleDelete}
        open={modalStatus}
      />{" "}
      {notifications && (
        <Dropdown isOpen={isOpen} toggle={toggleDropdown} nav>
          <DropdownToggle
            className="pr-0 notification-dropdown-toggle"
            data-cy={"notification-menu"}
            nav
            onClick={toggleDropdown}
          >
            <span data-count={unreadCount} className={"notification-icon cursor-pointer"}>
              <FaBell />
            </span>
          </DropdownToggle>
          <DropdownMenu right>
            {" "}
            <NotificationsList data={notifications} />
            {notifications.length > 0 && (
              <div style={{margin: "15px 10px"}} className="d-flex justify-content-end">
                {unreadCount > 0 && (
                  <Button
                    onClick={markAllAsRead}
                    type={"notification-button"}
                    data-cy={"mark-all-as-read"}
                  >
                    Mark all as read
                  </Button>
                )}
                <ProtectedContent perms={["delete_notification"]}>
                  <Button
                    onClick={showDeleteModal}
                    type={"notification-button"}
                    data-cy={"delete-all"}
                  >
                    Delete all
                  </Button>
                </ProtectedContent>
              </div>
            )}
          </DropdownMenu>
        </Dropdown>
      )}
    </Fragment>
  );
};

export default NotificationMenu;
